export const parseTokenToJSON = (token) => {
  let retVal = null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join('')
    );

    retVal = JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error parsing token: ', e);
  }

  return retVal;
};

export const isRefreshToken = (token) => {
  const decoded = parseTokenToJSON(token);

  return !!decoded?.token_type || decoded?.token_type === 'refresh';
};
